// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__jhdgh","titleText":"input_titleText__NFh6G","error":"input_error__1Jeco","headerText":"input_headerText__3s-6D","footerText":"input_footerText__3ip7n"};